import request from '@/utils/request'

// 注册账号
export const register = data => {
  return request({
    url: '/user/register',
    method: 'post',
    data
  })
}

// 登陆
export const login = data => {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}

// 重置密码
export const reset = data => {
  return request({
    url: '/user/reset',
    method: 'post',
    data
  })
}
